const ID_VIDROS_BASICO = 1;
const ID_VIDROS_COMPLETO = 2;
const CATEGORIAS_SEM_VIDROS_COMPLETO = [1, 2, 5];
const OPCAO_NENHUMA = { id: null, titulo: "Nenhuma" };

function extrairId(valor) {
  if (valor === null || valor === undefined) return null;
  if (typeof valor === "number") return valor;
  return typeof valor.id === "number" ? valor.id : null;
}

export default {
  ID_VIDROS_BASICO,
  ID_VIDROS_COMPLETO,
  CATEGORIAS_SEM_VIDROS_COMPLETO,
  OPCAO_NENHUMA,

  comOpcaoNenhuma(lista) {
    const opcoes = Array.isArray(lista) ? lista : [];
    const jaTem = opcoes.filter(opcao => extrairId(opcao) === null).length > 0;
    return jaTem ? opcoes : [{ id: null, titulo: OPCAO_NENHUMA.titulo }].concat(opcoes);
  },

  categoriaSemVidrosCompleto(catVeiculo) {
    const id = extrairId(catVeiculo);
    return id !== null && CATEGORIAS_SEM_VIDROS_COMPLETO.indexOf(id) !== -1;
  },

  filtrarOpcoes(lista, catVeiculo) {
    if (!Array.isArray(lista)) return [];
    if (!this.categoriaSemVidrosCompleto(catVeiculo)) return lista;
    return lista.filter(opcao => extrairId(opcao) !== ID_VIDROS_COMPLETO);
  },

  normalizarSelecao(coberturaVidros, catVeiculo, lista) {
    if (!this.categoriaSemVidrosCompleto(catVeiculo)) return coberturaVidros;
    if (extrairId(coberturaVidros) !== ID_VIDROS_COMPLETO) return coberturaVidros;
    if (typeof coberturaVidros === "number") return null;

    const nenhumaDaLista = Array.isArray(lista)
      ? lista.filter(opcao => opcao && extrairId(opcao) === null)[0]
      : null;

    return nenhumaDaLista || null;
  },

  normalizarLista(itens, lista) {
    if (!Array.isArray(itens) || !itens.length) return;
    if (!Array.isArray(lista) || !lista.length) return;

    itens.forEach(item => {
      if (!item) return;
      item.coberturaVidros = this.normalizarSelecao(
        item.coberturaVidros,
        item.catVeiculo,
        lista
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/helpers/cobertura-vidros.js